import React from 'react';
import {connect} from 'react-redux';
import {defineMessages, FormattedMessage} from 'react-intl';

import {join as joinAction, changeJoinType as changeJoinTypeAction} from 'actions/auth/Join';
import {join as fastJoinAction, confirmPhone as fastConfirmAction} from 'actions/auth/FastJoin';
import {cancelJoin as cancelJoinAction} from 'actions/creators/Auth';

import FastRegistrationForm from './registration/fast/FastRegistrationForm.jsx';
import FastJoinPhoneConfirmation from './registration/fast/PhoneConfirmation.jsx';
import FastRegistrationSuccess from './registration/fast/PhoneRegistrationSuccess.jsx';
import FastJoinEmailSuccess from './registration/fast/EmailRegistrationSuccess.jsx';

import RegistrationForm from './registration/regular/RegistrationForm.jsx';
import PhoneConfirmation from './registration/regular/PhoneConfirmation.jsx';
import RegistrationSuccess from './registration/regular/RegistrationSuccess.jsx';

import * as JoinType from 'constants/JoinType';
import * as FastJoinType from 'constants/FastJoinType';
import * as JoinStage from 'constants/JoinStage';
import { RU, EN, UZ, KK } from 'constants/Language';

import accountResourcesAll from 'shared/dictionaries/accountResources.json';
import accountResourcesUz from 'shared/dictionaries/accountResourcesUz.json';
import languages from 'shared/dictionaries/languages.json';
import timezones from 'shared/dictionaries/timezones.json';
import ruCountries from 'shared/dictionaries/availableCountries/ru.json';
import enCountries from 'shared/dictionaries/availableCountries/en.json';
import uzCountries from 'shared/dictionaries/availableCountries/uz.json';
import kkCountries from 'shared/dictionaries/availableCountries/kk.json';
import fastJoinCountriesRu from 'shared/dictionaries/fast-join-countries/ru.json';
import fastJoinCountriesEn from 'shared/dictionaries/fast-join-countries/en.json';
import fastJoinCountriesUz from 'shared/dictionaries/fast-join-countries/uz.json';
import fastJoinCountriesKk from 'shared/dictionaries/fast-join-countries/kk.json';
import { getInitialCountryCode } from 'shared/utils/functions';

const languageCountriesMap = {
    [RU]: ruCountries,
    [2]: ruCountries,
    [3]: ruCountries,
    [4]: ruCountries,
    [EN]: enCountries,
    [UZ]: uzCountries,
    [KK]: kkCountries
};

const languageFastJoinCountriesMap = {
    [RU]: fastJoinCountriesRu,
    [EN]: fastJoinCountriesEn,
    [UZ]: fastJoinCountriesUz,
    [KK]: fastJoinCountriesKk
};

const messages = defineMessages({
    title: {
        id: 'join.title',
        defaultMessage: 'Регистрация'
    },
    fastTitle: {
        id: 'join.fast_registration_title',
        defaultMessage: 'Быстрая Регистрация'
    },
    regularTitle: {
        id: 'join.registration_title',
        defaultMessage: 'Обычная Регистрация'
    }
});

class Join extends React.Component {
    static propTypes = {
        languageId: React.PropTypes.number.isRequired,
        joinType: React.PropTypes.number.isRequired,
        joinStage: React.PropTypes.number.isRequired,
        joining: React.PropTypes.bool.isRequired,
        joinError: React.PropTypes.any,
        promoCodeError: React.PropTypes.any,
        userRegistration: React.PropTypes.any,
        fastJoin: React.PropTypes.any,
        phoneConfirming: React.PropTypes.bool.isRequired,
        phoneConfirmationRequested: React.PropTypes.bool.isRequired,
        phoneConfirmed: React.PropTypes.bool.isRequired,
        phoneConfirmationError: React.PropTypes.any,
        domain: React.PropTypes.string.isRequired,
        joinAction: React.PropTypes.func.isRequired,
        fastJoinAction: React.PropTypes.func.isRequired,
        fastConfirmAction: React.PropTypes.func.isRequired,
        cancelJoinAction: React.PropTypes.func.isRequired,
        changeJoinTypeAction: React.PropTypes.func.isRequired
    };

    static _renderTab(label, itemClass, clickHandler) {
        return (
            <li className={itemClass} onClick={clickHandler}>
                <FormattedMessage {...label} />
            </li>
        );
    }

    constructor(props) {
        super(props);

        this._handleCloseClick = this._handleCloseClick.bind(this);
        this._tabChange = this._tabChange.bind(this);
    }

    _tabChange(type) {
        this.props.changeJoinTypeAction({joinType: type})
    }

    _handleCloseClick(e) {
        e.preventDefault();
        this.props.cancelJoinAction();
    }

    renderHeader() {
        return (<div className="modal--header">
            <div className="header-inner--logotype__link" />
            <div className="header-inner__title">
                <FormattedMessage {...messages.title}/>
            </div>
            <button className="modal__close modal__close__green modal__close__js"
                    onClick={this._handleCloseClick}/>
            <div className="tabs">
                {this._renderMenu()}
            </div>
        </div>);
    }

    _renderMenu() {
        const {joinType} = this.props;

        const listItemClass = 'main-tabs--list__item tabs--list__item main-tabs--list__item__js';
        const listActiveItemClass = 'main-tabs--list__item tabs--list__item main-tabs--list__item__js active';

        const fastJoinClass = (joinType === JoinType.FAST) ? listActiveItemClass : listItemClass;
        const regularJoinClass = (joinType === JoinType.REGULAR) ? listActiveItemClass : listItemClass;

        const fastJoinClick = this._tabChange.bind(this, JoinType.FAST);
        const regularJoinClick = this._tabChange.bind(this, JoinType.REGULAR);

        return (
            <ul className="main-tabs--list tabs--list">
                {Join._renderTab(messages.fastTitle, fastJoinClass, fastJoinClick)}
                {Join._renderTab(messages.regularTitle, regularJoinClass, regularJoinClick)}
            </ul>
        );
    }

    renderFastJoin() {
        const {
            languageId,
            joinStage,
            joining,
            joinError,
            promoCodeError,
            fastJoin,
            fastJoinAction,
            fastConfirmAction,
            cancelJoinAction,
            domain
            } = this.props;

        const countries = languageFastJoinCountriesMap[languageId];
        const { defaultCountryId, accountResourceId } = getInitialCountryCode(this.props.countryCode);
        const defaultCountry = countries[defaultCountryId];

        const countryCode = defaultCountry.mask;
        const countryNumberLength = defaultCountry.length;
        const accountResources = this.props.countryCode === 'UZ' ? accountResourcesUz : accountResourcesAll;

        const defaultValues = {
            initialValues: {
                type: FastJoinType.SMS,
                agree: false,
                accountResourceId,
                countryId: defaultCountryId,
                countryCode,
                countryNumberLength
            }
        };

        const registrationProps = {
            languageId,
            joining,
            joinError,
            promoCodeError,
            fastJoin,
            submitAction: fastJoinAction,
            accountResources,
            countries,
            domain,
            ...defaultValues
        };

        const phoneConfirmationProps = {
            languageId,
            inProcess: joining,
            error: joinError,
            fastJoin,
            countryCode: this.props.countryCode,
            confirmPhone: fastConfirmAction,
            resendCode: fastJoinAction,
            closeCallback: this._handleCloseClick
        };

        const phoneSuccessProps = {
            languageId,
            domain,
            finalizeJoin: cancelJoinAction
        };

        const email = fastJoin ? fastJoin.get('Email') : '';

        const emailSuccessProps = {
            languageId,
            email,
            cancelCallback: this._handleCloseClick
        };

        if (joinStage === JoinStage.SUCCESS) {
            return (<FastRegistrationSuccess {...phoneSuccessProps}/>);
        }

        if (joinStage === JoinStage.EMAIL_SENT) {
            return (<FastJoinEmailSuccess {...emailSuccessProps}/>);
        }

        return (
            <div className="modal--registration">
                {this.renderHeader()}
                <div className="modal--content">
                    <div className="modal--content__wrapper">
                        <div className="main-tabs--content tabs-content">
                            {joinStage === JoinStage.INIT &&
                            <FastRegistrationForm {...registrationProps} />}
                            {joinStage === JoinStage.PHONE_CONFIRMATION &&
                            <FastJoinPhoneConfirmation {...phoneConfirmationProps}/>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderRegularJoin() {
        const {languageId, joinStage, joining, joinError, userRegistration, promoCodeError,
            phoneConfirming, phoneConfirmationRequested, phoneConfirmed, phoneConfirmationError,
            joinAction, domain} = this.props;

        const countries = languageCountriesMap[languageId];
        const { defaultCountryId, accountResourceId } = getInitialCountryCode(this.props.countryCode);
        const defaultCountry = countries[defaultCountryId];

        const countryCode = defaultCountry.mask;
        const countryNumberLength = defaultCountry.length;
        const accountResources = this.props.countryCode === 'UZ' ? accountResourcesUz : accountResourcesAll;


        const defaultValues = {
            initialValues: {
                agree: false,
                accountResourceId,
                countryId: defaultCountryId,
                countryCode,
                countryNumberLength,
                timezoneId: 1
            }
        };

        const registrationProps = {
            languageId,
            joining,
            joinError,
            promoCodeError,
            submitAction: joinAction,
            cancelCallback: this._handleCloseClick,
            accountResources,
            countries,
            languages,
            timezones,
            domain,
            ...defaultValues
        };

        let gamblerId;
        let phone;
        let email;
        let joinPromoType;
        if (userRegistration) {
            gamblerId = userRegistration.get('gamblerId');
            phone = userRegistration.get('phone');
            email = userRegistration.get('email');
            joinPromoType = userRegistration.get('joinPromoType');
        }

        const registrationSuccessProps = {
            languageId,
            email,
            cancelCallback: this._handleCloseClick
        };

        const phoneConfirmationProps = {
            languageId,
            gamblerId,
            joinPromoType,
            countryCode: this.props.countryCode,
            phone,
            phoneConfirming,
            phoneConfirmationRequested,
            phoneConfirmationError,
            phoneConfirmed,
            cancelCallback: this._handleCloseClick
        };

        return (
            <div className="modal--registration">
                {joinStage === JoinStage.INIT && this.renderHeader()}
                {joinStage === JoinStage.INIT &&
                <div className="modal--content">
                    <div className="modal--content__wrapper">
                        <div className="main-tabs--content tabs-content">
                            <RegistrationForm {...registrationProps} />
                        </div>
                    </div>
                </div>}
                {joinStage === JoinStage.PHONE_CONFIRMATION && <PhoneConfirmation {...phoneConfirmationProps}/>}
                {joinStage === JoinStage.SUCCESS && <RegistrationSuccess {...registrationSuccessProps}/>}
            </div>
        );
    }

    render() {
        const {joinType} = this.props;

        return (
            <div className="modal modal--auth modal--auth__simple-registration modal__visible ">
                {joinType === JoinType.FAST && this.renderFastJoin()}
                {joinType === JoinType.REGULAR && this.renderRegularJoin()}
            </div>
        );
    }
}

function select(state) {
    return {
        languageId: state.application.get('languageId'),
        countryCode: state.application.get('countryCode'),
        joinType: state.join.get('type'),
        joinStage: state.join.get('stage'),
        joining: state.join.get('inProcess'),
        joinError: state.join.get('error'),
        promoCodeError: state.join.get('PromocodeError'),
        userRegistration: state.join.get('userRegistration'),
        fastJoin: state.join.get('fastJoin'),
        phoneConfirming: state.phoneConfirm.get('inProcess'),
        phoneConfirmationError: state.phoneConfirm.get('error'),
        phoneConfirmationRequested: state.phoneConfirm.get('requested'),
        phoneConfirmed: state.phoneConfirm.get('confirmed'),
        domain: state.domain
    };
}

export default connect(select,
    {joinAction, cancelJoinAction, fastJoinAction, fastConfirmAction, changeJoinTypeAction})(Join);



// WEBPACK FOOTER //
// ./js/sport-betting/components/Join.jsx